module.exports = __webpack_public_path__ + "img/15.24605a78.jpg";